import React from "react";
import "../styles/About.css";
import ProgressLine from "../helpers/ProgressLine";
import Me from "../photos/me.png";

function About() {
  return (
    <div className="about">
      <div className="about__body">
        <div className="about__bodyMe">
          <img className="about__bodyMePhoto" src={Me} alt="" />
          <h1 style={{ color: "#7DE0CE" }} className="about__bodyTitle">
            01.About Me
          </h1>
          <p className="about__bodyMetext">
            I'm a junior Software Engineering student in Bahçeşehir University
            in Istanbul/Turkey. I have passion for UI effects & dynamic user
            experiences.I enjoy creating things that live on the internet,
            whether that be websites, applications, or anything in between.
          </p>
        </div>

        <div className="languages">
          <ProgressLine
            label="Javascript"
            backgroundColor="#ccd6f6"
            visualParts={[
              {
                percentage: "75%",
                color: "#5ed6c0",
              },
            ]}
          />

          <ProgressLine
            label="Node.js"
            backgroundColor="#ccd6f6"
            visualParts={[
              {
                percentage: "70%",
                color: "#5ed6c0",
              },
            ]}
          />

          <ProgressLine
            label="React.js"
            backgroundColor="#ccd6f6"
            visualParts={[
              {
                percentage: "60%",
                color: "#5ed6c0",
              },
            ]}
          />

          <ProgressLine
            label="Html & Css"
            backgroundColor="#ccd6f6"
            visualParts={[
              {
                percentage: "75%",
                color: "#5ed6c0",
              },
            ]}
          />

          <ProgressLine
            label="Java & Spring Boot"
            backgroundColor="#ccd6f6"
            visualParts={[
              {
                percentage: "55%",
                color: "#5ed6c0",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default About;
